interface LoyaltyManagementState {
  tasks: any[];
  selectedModule: string | null;
}

const initialState: LoyaltyManagementState = {
  tasks: [],
  selectedModule: null,
};

const loyaltyManagementReducer = (
  state = initialState,
  action: any
): LoyaltyManagementState => {
  switch (action.type) {
    case "SET_TASKS":
      return { ...state, tasks: action.payload };
    case "SET_SELECTED_MODULE":
      return { ...state, selectedModule: action.payload };
    default:
      return state;
  }
};

export default loyaltyManagementReducer;
